var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider__counter",class:_vm.zoomStateClass},[_vm._v(" Page "+_vm._s(_vm.index + 1)+" / "+_vm._s(_vm.length)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }